module.exports = require('./helpers/bundle-url').getBundleURL('iE43R') + "logo-dark.eefe0b7f.svg";